import InventoryPaymentSnapshot from './InventoryPaymentSnapshot';

export default InventoryPaymentSnapshot;
